/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { DeleteAdminDatasetDataType } from './AdminDatasetsPage.types';

export const invisibleRowBC: string = 'rgba(170, 170, 170, .09)';

export const notExistedRowBC: string = 'rgba(230, 0, 0, .05)';

export const deleteAdminDatasetInitialValues: DeleteAdminDatasetDataType = {
  id: '',
  name: '',
  isModalOpened: false,
};
